
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "MessageDialog"
})
export default class extends Vue {
  @PropSync("visible", { type: Boolean })
  private syncedVisible;

  @Prop(Function)
  private updateMethod;

  @Prop(Array)
  private messages: Array<{ messageTitle: string, messageContent: string, readFlag: number, sendTime: string }>;

  private currentIndex: number = 0;

  get currentMessage() {
    return this.messages[this.currentIndex];
  }

  get messageCount() {
    return this.messages.length;
  }

  get messageContent() {
    const message = this.currentMessage
    if (!message || !message.messageContent) {
      return ''
    }
    return message.messageContent;
  }

  @Watch('currentMessage', { immediate: true })
  onMessageRead(message) {
    if (!message) {
      return;
    }

    if (this.updateMethod && !message.readFlag) {
      message.readFlag = 1;
      this.updateMethod(message.id);
    }
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  next() {
    if (this.currentIndex < this.messages.length - 1) {
      this.currentIndex++;
    }
  }

  onOK() {
    this.syncedVisible = false;
  }
}
